<ion-button class="secondary" *ngIf="!testing" (click)="startTestEquipment()">Start Test Recording</ion-button>
<!-- <ion-button class="secondary" *ngIf="!testing" (click)="showModal()">Show Modal</ion-button> -->

<div *ngIf="testing" class="testing-container">
  <p>{{ stoppingTest ? 'Stopping test!' : progressText }}</p>
  <ion-progress-bar color="secondary" [value]="progress" [buffer]="1"></ion-progress-bar>
  <ion-button class="secondary" (click)="forceStopTestEquipment()" [disabled]="stoppingTest">Stop Test</ion-button>
</div>
